import React from 'react'
import Filter from '../../../Auxiliar/Filter';
import Transportadoras from './Transportadoras';
import Compliances from '../Compliance/Compliances';

const SelecionarTransportadoras = () => {
  const [search, setSearch] = React.useState(false)
  const [dateOf, setDateOf] = React.useState('')
  const [dateFor, setDateFor] = React.useState('')
  const [options, setOptions] = React.useState({
    transportadoras: { value: true, label: 'Transportadoras', checked: true },
    compliances: { value: false, label: 'Compliances', checked: false },
  })

  return (
    <div className="card">
      <div className="card-body" id="card">
        <h4 className="mt-0 header-title" style={{ fontSize: '1.5rem', color: 'black' }}>Transportadoras</h4>
        <Filter setDateOf={setDateOf} setDateFor={setDateFor} options={options} setOptions={setOptions} setSearch={setSearch} />
        <div>
          <p style={{ fontSize: '1rem', color: 'black' }}>Aqui são listadas as transportadoras do sistema</p>
        </div>
        <div className="row">
          {options.transportadoras.value &&
            <Transportadoras dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} />}
          {options.compliances.value &&
            <Compliances dateOf={dateOf} dateFor={dateFor} search={search} setSearch={setSearch} owner={'transportadoras'} searchFor='carrier_id' />}
        </div>
      </div>
    </div>
  )
}

export default SelecionarTransportadoras